import { Component } from 'react'
import PropTypes from 'prop-types'
import Panel from 'beam/dist/Panel'
import BeamIcon from 'beam/dist/BeamIcon'
import withStyles from 'beam/dist/styles/index'
import { withTranslation } from 'react-i18next'

import SpeechHitsMultiMenu from './SpeechHitsMultiMenu'
import ErrorBoundary from '../ErrorBoundary'
import SpeechHitsContent from './SpeechHitsContent'

const dataTestIdPrefix = 'App-Recordings-MediaPlayer-SpeechHitsPanel-'

const styles = theme => ({
  rootNoData: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    flexGrow: 1,
  },
  panelRoot: {
    boxShadow: 'none',
  },
  panelBody: {
    padding: theme.spacing(1, 0),
  },
})

class SpeechHitsPanel extends Component {
  static displayName = 'SpeechHitsPanel'

  static propTypes = {
    t: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    speechHits: PropTypes.array,
    contactId: PropTypes.number.isRequired,
  }

  constructor(props) {
    super(props)
    this.all = props.t('all')
    this.state = {
      selectedCategory: this.all,
    }
  }

  getCategories() {
    const { speechHits } = this.props
    return Object.keys(
      speechHits.reduce(
        (cats, hit) => {
          cats[hit.category] = hit.category
          return cats
        },
        {
          [this.all]: this.all,
        },
      ),
    )
  }

  changeCategory(category) {
    this.setState({ selectedCategory: category })
  }

  render() {
    const { t, classes, ...contentProps } = this.props

    return (
      <Panel
        titleIcon={<BeamIcon>CommentCheckOutline</BeamIcon>}
        title={t(['phraseHits', 'Phrase Hits'])}
        classes={{ root: classes.panelRoot, body: classes.panelBody }}
        dense
        variant="light"
        dataTestId={`${dataTestIdPrefix}panel`}
        headerTestId={`${dataTestIdPrefix}panel-heading`}
        headerActions={
          <SpeechHitsMultiMenu
            categories={this.getCategories()}
            selectedCategory={this.state.selectedCategory}
            onCategoryChange={this.changeCategory.bind(this)}
          />
        }
      >
        <ErrorBoundary key={contentProps.contactId}>
          <SpeechHitsContent allCategory={this.all} selectedCategory={this.state.selectedCategory} {...contentProps} />
        </ErrorBoundary>
      </Panel>
    )
  }
}

export { SpeechHitsPanel as UnstyledSpeechHitsPanel }

export default withTranslation()(withStyles(styles)(SpeechHitsPanel))
